import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { getUserDetail, updateUserCurrency, updateUserTimezone } from "store/actions";
import { BlobServiceClient } from '@azure/storage-blob';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { API_URL } from "helpers/app_url";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import CurrencyDropdown from "components/dropdowns/Other/CurrencyDropdowns";
import UpdateButton from "components/buttons/updateBtn";
import TimeZone from "components/dropdowns/Other/TimeZone";
import ProfileSidebar from "components/VerticalLayout/profileSidebar";
import { azureConfig } from "helpers/azureConfig";
import Swal from "sweetalert2";
import SafeField from "helpers/SafeField";
import { UPLOADTEXT } from "constants/layout";
class agentProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
         
    }
    this.handelSubmitProfile = this.handelSubmitProfile.bind(this);
  }
 handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };


 async handleAgentLogo(event, setFieldValue) {
    
     const file = event.currentTarget.files[0];
          if (file) {
            const maxSize = 5 * 1024 * 1024;
            const allowedTypes = [
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/svg+xml',
          ];

          const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.svg'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
              Swal.fire({
                title: 'File type or extension not allowed',
                text: 'Please upload a JPG, PNG, WEBP, SVG file.',
                icon: 'warning',
                confirmButtonText: 'OK',
              });
              //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
              return;
            }
            if (file.size > maxSize) {
              Swal.fire({
                title: 'Size not allowed',
                text: 'Please Upload Maximum 5MB File',
                icon: 'warning',
                confirmButtonText: 'OK',
              });
             
            }
      const sanitizedFileName = file.name.replace(/\s+/g, '_');     
      const sasToken = azureConfig.sasToken;
      const containerName = azureConfig.containerName;
      const storageAccountName = azureConfig.storageAccountName;
     const fileName = `${Date.now()}_${sanitizedFileName}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });

        //alert('File uploaded successfully!');
        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`logoFilePath`, fileUrl);
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }

 async handleAgentImage(event, setFieldValue) {
    const file = event.currentTarget.files[0];
          if (file) {
            const maxSize = 5 * 1024 * 1024;
            const allowedTypes = [
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/svg+xml',
          ];

          const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.svg'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
              Swal.fire({
                title: 'File type or extension not allowed',
                text: 'Please upload a JPG, PNG, WEBP, SVG file.',
                icon: 'warning',
                confirmButtonText: 'OK',
              });
              //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
              return;
            }
            if (file.size > maxSize) {
              Swal.fire({
                title: 'Size not allowed',
                text: 'Please Upload Maximum 5MB File',
                icon: 'warning',
                confirmButtonText: 'OK',
              });
             
            }
       const sanitizedFileName = file.name.replace(/\s+/g, '_');    
      const sasToken = azureConfig.sasToken;
      const containerName = azureConfig.containerName;
      const storageAccountName = azureConfig.storageAccountName;
      const fileName = `${Date.now()}_${sanitizedFileName}`;

      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });

        //alert('File uploaded successfully!');
        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`agentImageFilePath`, fileUrl);
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }

  handelSubmitProfile(values){
    const payload = {
                    id: values.id,
                    agentId:values.agentId,
                    agentCode:values.agentCode,
                    title:values.title,
                    firstName:values.firstName,
                    lastName:values.lastName,
                    organizationName:values.organizationName,
                    addressId:values.addressId,
                    contactId:values.contactId,
                    logoFilePath:values.logoFilePath,
                    agentImageFilePath:values.agentImageFilePath,
                    logoContent:values.logoContent,
                    fullAddress:values.fullAddress,
                    addressLine1:values.addressLine1,
                    addressLine2:values.addressLine2,
                    nearestIntersection: values.nearestIntersection,
                    city: values.city,
                    province:values.province,
                    postal:values.postal,
                    country:values.country,
                    longitude:values.longitude || 0,
                    latitude:values.latitude || 0,
                    phone:values.phone,
                    phoneExt:values.phoneExt,
                    mobile:values.mobile
    }
              const obj = JSON.parse(localStorage.getItem("authUser"));
              const token = obj.resultData.bearerToken;
              const str =  `Bearer ${token}`;
              toast.loading("Please wait...")
              fetch(`${API_URL}AgentExt/UpdateAgentExt2`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': str,
                },
                body: JSON.stringify(values)
              })
              .then(response => response.json())
              .then(data => {
                toast.dismiss();
                if (data.success) {
                    toast.success("Updated successfully.");
                } else {
                    toast.error("Failed to submit questions. Please try again.");
                }
            })
            .catch(error => {
                toast.dismiss();
                toast.error("Error occurred while submitting. Please try again.");
                  console.error('Error:', error);
            });
    
  }
 componentDidMount() {
    const { onGetUserDetail } = this.props;
      onGetUserDetail(localStorage.getItem('userId'));
  }
render() {
  const { userdetail, onUpdateUserCurrency, onUpdateUserTimezone } = this.props;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Agent Profile | Realty Space</title>
          </MetaTags>
          <Container fluid>
          
       
          <Row className="mb20">
            <Col xl="6">
             <Breadcrumbs
              title={this.props.t("Agent")}
              breadcrumbItem={this.props.t("Profile")}
            />
           
            </Col>
           
            </Row>
            <Row>
              <Col xl="3">
                <ProfileSidebar />
              </Col>
              
              <Col xl="9">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: userdetail?.id,
                    agentId:userdetail?.agentId,
                    agentCode:userdetail?.agentCode,
                    title:userdetail?.title,
                    firstName:userdetail?.firstName,
                    lastName:userdetail?.lastName,
                    organizationName:userdetail?.organizationName,
                    primaryEmail: userdetail?.primaryEmail,
                    addressId:userdetail?.addressId,
                    contactId:userdetail?.contactId,
                    logoFilePath:userdetail?.logoFilePath,
                    agentImageFilePath:userdetail?.agentImageFilePath,
                    logoContent:userdetail?.logoContent,
                    fullAddress:userdetail?.agentAddress?.fullAddress,
                    addressLine1:userdetail?.agentAddress?.addressLine1,
                    addressLine2:userdetail?.agentAddress?.addressLine2,
                    nearestIntersection: userdetail?.agentAddress?.nearestIntersection,
                    city: userdetail?.agentAddress?.city,
                    province:userdetail?.agentAddress?.province,
                    postal:userdetail?.agentAddress?.postal,
                    country:userdetail?.agentAddress?.country,
                    longitude:userdetail?.agentAddress?.longitude,
                    latitude:userdetail?.agentAddress?.latitude,
                    phone:userdetail?.agentContact?.cContact?.phone,
                    phoneExt:userdetail?.agentContact?.cContact?.phoneExt,
                    mobile:userdetail?.agentContact?.cContact?.mobile
                  }}
                  validationSchema={Yup.object().shape({
                   
                    //title: Yup.string().required("This is required"),
                    firstName:Yup.string().required("This is required"),
                    lastName:Yup.string().required("This is required"),
                    mobile:Yup.string().required("This is required"),
                    primaryEmail: Yup.string()
                    .required("This is required")
                    .email("Please enter a valid email address"),
                  })}

                  onSubmit={this.handelSubmitProfile}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             

         
                <Card className="border-full"> 
                    <CardBody>
                    <h5 className="card-title">Update Profile</h5>
              
                   <Row>
                        {/* <Col sm="1">
                         <TitleDropdowns
                          name="title"
                          label="Title *"
                          fieldName="Agent:Title"
                          
                        />
                        </Col> */}

                        <Col sm="3">
                        <FormGroup className="mb-3">
                            <Label htmlFor="firstName">
                              {this.props.t("First Name *")}
                            </Label>
                            <SafeField
                              name="firstName"
                              onChange={handleChange}  
                                 
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.firstName && touched.firstName
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="firstName"
                            />
                             <ErrorMessage
                              name="firstName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                        <FormGroup className="mb-3">
                            <Label htmlFor="lastName">
                              {this.props.t("Last Name *")}
                            </Label>
                            <SafeField
                              name="lastName"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.lastName && touched.lastName
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="lastName"
                            />
                             <ErrorMessage
                              name="lastName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>     
                        <Col sm="3">
                          <PhoneInputField
                            label="Mobile"
                            name="mobile"
                            value={values.mobile}
                            setFieldValue={setFieldValue}
                            error={errors.mobile}
                            touched={touched.mobile}
                            country="ca"
                            required={true}
                          />
                   
                        </Col>
                  
                        <Col sm="2">
                         <PhoneInputField
                            label="Office Phone"
                            name="phone"
                            value={values.phone}
                            setFieldValue={setFieldValue}
                            error={errors.phone}
                            touched={touched.phone}
                            country="ca"
                            required={false}
                          />
                   
                         
                            </Col>
                            <Col sm="1">
                            <FormGroup className="mb-3">
                            <Label htmlFor="phoneExt">
                              {this.props.t("Ext")}
                            </Label>
                            <SafeField
                              name="phoneExt"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.phoneExt && touched.phoneExt
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="phoneExt"
                            />
                             <ErrorMessage
                              name="phoneExt"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                            </Col> 
                 
                        </Row>
                           

                            <Row>
                             <Col sm="3">
                            <FormGroup className="mb-3">
                            <Label htmlFor="primaryEmail">
                              {this.props.t("Email *")}
                            </Label>
                            <SafeField
                              name="primaryEmail"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.primaryEmail && touched.primaryEmail
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="primaryEmail"
                            />
                             <ErrorMessage
                              name="primaryEmail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                            </Col>
                            <Col sm="3">
                            <FormGroup className="mb-3">
                            <Label htmlFor="organizationName">
                              {this.props.t("Office Name")}
                            </Label>
                            <SafeField
                              name="organizationName"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.organizationName && touched.organizationName
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="organizationName"
                            />
                             <ErrorMessage
                              name="organizationName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                            </Col>
                            <Col sm="6">
                            <FormGroup className="mb-3">
                            <Label htmlFor="address">
                              {this.props.t("Office Address")}
                            </Label>
                             <PlacesAutocomplete
                                value={values.fullAddress}
                                onChange={(value) => setFieldValue('fullAddress', value)}
                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                            >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                      <input
                                        {...getInputProps({
                                          placeholder: 'Enter Address...',
                                          className: 'form-control',
                                        
                                        })}
                                      />
                                      <div className="">
                                        {loading ? <div>Loading...</div> : null}

                                        {suggestions.map((suggestion, i) => {
                                          const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                          const style = suggestion.active
                                            ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                            : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                          return (
                                            <div
                                            key={i}
                                              {...getSuggestionItemProps(suggestion, {
                                                style,
                                              })}
                                            >
                                              {suggestion.description}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                             <ErrorMessage
                              name="address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                            </Col>
                              </Row>

                              <Row>
                                     <Col sm="3">
                            <FormGroup className="mb-3">
                            <Label htmlFor="agentCode">
                              {this.props.t("License Number")}
                            </Label>
                            <SafeField
                              name="agentCode"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.agentCode && touched.agentCode
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="agentCode"
                            />
                             <ErrorMessage
                              name="agentCode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                            </Col>
                            {userdetail?.isSingleRealtor > 0 &&(

                          
                            <Col sm="3">
                        <div className="form-group mb-3">
                          <Label htmlFor="file">Upload Logo</Label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={event => this.handleAgentLogo(event, setFieldValue)}
                          />
                          <small className="text-muted font-size-12">{UPLOADTEXT.GIMG}</small>
                          <div className="clearfix"></div>
                           {values.logoFilePath	 != '' ?
                                      <img src={values.logoFilePath} className="img-thumbnail"></img>
                                      : ''
                                    }
                        </div>
                        </Col>
                          )}
                          <Col sm="3">
                        <div className="form-group mb-3">
                          <Label htmlFor="file">Upload Agent Image</Label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={event => this.handleAgentImage(event, setFieldValue)}
                          />
                           <small className="text-muted font-size-12">{UPLOADTEXT.GIMG}</small>
                          <div className="clearfix"></div>
                            {values.agentImageFilePath	 != '' ?
                                      <img src={values.agentImageFilePath} className="img-thumbnail"></img>
                                      : ''
                                    }
                        </div>
                        </Col>
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md float-left mt-27">Update Profile</button></div>     
                            </Row>
             
             </CardBody>
                </Card>
</Form>
)}
              </Formik>

                                      <Row>
                                        <Col sm="6">
                                         <Formik
                                                  enableReinitialize={true}
                                                  initialValues={{
                                                      id: userdetail?.id,
                                                      agentId: userdetail?.agentId,
                                                      agentCurrencyCode: (userdetail?.agentDefaultCurrencyCode) ? userdetail?.agentDefaultCurrencyCode : this.state.agentCurrencyCode,
                                                  }}
                                                  validationSchema={Yup.object().shape({
                                                    agentCurrencyCode: Yup.string().required("This is required"),
                                                  })}
                                                  onSubmit={values => {
                                                      onUpdateUserCurrency(values)
                                                  }}
                                              >
                                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                      <Form
                                                          className="needs-validation"
                                                      >
                                                          <Card className="border-full">
                                                              <CardBody>
                                                                <h5 className="card-title">Currency</h5>
                                                                  <Row>
                                                                      <Col sm="8">
                                                                          <CurrencyDropdown name="agentCurrencyCode" label="Select" />
                                                                      </Col>
                                                                      <Col sm="4">
                                                                          <button type="submit" className="btn btn-primary w-md float-left" style={{marginTop:30}}>Update Currency</button>
                                                                      </Col>
                                                                  </Row>
                                                              </CardBody>
                                                          </Card>
                                                      </Form>
                                                  )}
                                              </Formik>
                                        </Col>


                                         <Col sm="6">
                                         <Formik
                                                  enableReinitialize={true}
                                                  initialValues={{
                                                      id: userdetail?.id,
                                                      agentId: userdetail?.agentId,
                                                      timeZoneId: userdetail?.timeZoneId
                                                  }}
                                                  validationSchema={Yup.object().shape({
                                                    timeZoneId: Yup.string().required("This is required"),
                                                  })}
                                                  onSubmit={values => {
                                                      onUpdateUserTimezone(values)
                                                  }}
                                              >
                                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                      <Form
                                                          className="needs-validation"
                                                      >
                                                          <Card className="border-full">
                                                              <CardBody>
                                                                <h5 className="card-title">Time Zone</h5>
                                                                  <Row>
                                                                      <Col sm="8">
                                                                          <TimeZone name="timeZoneId" label="Select" />
                                                                      </Col>
                                                                      <Col sm="4">
                                                                          <button type="submit" className="btn btn-primary w-md float-left" style={{marginTop:30}}>Update Time Zone</button>
                                                                      </Col>
                                                                  </Row>
                                                              </CardBody>
                                                          </Card>
                                                      </Form>
                                                  )}
                                              </Formik>
                                        </Col>
                                      </Row>
                                            


 
            
            </Col>
            
            </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
agentProfile.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
  onGetUserDetail:PropTypes.func,
  userdetail:PropTypes.object,
  onUpdateUserCurrency:PropTypes.func,
  onUpdateUserTimezone:PropTypes.func

}
const mapStateToProps = ({Login}) => (
  {
    userdetail : Login.userdetail
  })
const mapDispatchToProps = dispatch => ({
  
  onGetUserDetail:(id) => dispatch(getUserDetail(id)),
   onUpdateUserCurrency:(data) => dispatch(updateUserCurrency(data)),
   onUpdateUserTimezone:(data) => dispatch(updateUserTimezone(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(agentProfile))
